import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { GuiService } from './gui.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TimeChallengeService {
  challenge: any = null;
  acceptedChallenge: any = null;
  countdown: { days: number, hours: number, minutes: number, seconds: number } | null = null;
  intervalTimer: any;
  showCountdown: boolean = false;
  selectedChallenge;

  constructor(private restService: RestService, private guiService: GuiService, public translate: TranslateService) { }

  getLastTimeChallenge() {
    if (this.guiService.userLogged) {
      const param = {
        userId: this.guiService.userLogged.user.id
      }
      this.restService.postService('node', '/get-last-time-challenge', param).subscribe((ris) => {
        console.debug(ris);
        this.checkChallengeValidity(ris);
      })
    }
  }

  checkChallengeValidity(item) {
    const startDate = moment(item.startDate);
    const endDate = moment(item.endDate);
    const today = moment();

    if (today.isSameOrAfter(startDate, 'day') && today.isSameOrBefore(endDate, 'day')) {
      this.checkAcceptance(item);
    } else {
      console.log("Oggi non è nel range valido.");
      this.challenge = null;
    }
  }

  checkAcceptance(item) {
    const param = {
      userId: this.guiService.userLogged.user.id,
      challengeId: item._id
    }
    this.restService.postService('node', '/check-time-challenge', param).subscribe((ris) => {
      console.debug(ris);
      const today = moment();
      const endAcceptancePeriod = moment(item.startDate).add(item.acceptancePeriod, 'days');
      if (ris !== false) {
        console.debug('già accettato')
        if (today.isSameOrBefore(endAcceptancePeriod, 'day')) {
          const countdownTime = item.challenges[ris.challengeNumber].weeks[0].publishDate;
          this.startCountdown(moment(countdownTime).diff(moment()));
        }
        this.challenge = item;
        this.acceptedChallenge = ris;
        this.selectedChallenge = ris.challengeNumber;
      } else {
        if (today.isSameOrBefore(endAcceptancePeriod, 'day')) {
          console.debug('può ancora accettare')
          this.challenge = item;
        } else {
          this.challenge = null;
          this.acceptedChallenge = null;
        }
      }
    })
  }

  startCountdown(milliseconds: number): void {
    console.debug(milliseconds)
    const endTime = Date.now() + milliseconds;
    this.intervalTimer = setInterval(() => {
      const now = Date.now();
      const timeRemaining = endTime - now;
      if (timeRemaining <= 0) {
        clearInterval(this.intervalTimer);
        this.countdown = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        this.showCountdown = false;
      } else {
        this.showCountdown = true;
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
        this.countdown = { days, hours, minutes, seconds };
      }
    }, 1000);
  }

  challengeStartedBy() {
    const remainingDays = moment(this.challenge.endDate).diff(moment(), 'days') + 1;
    if (remainingDays > 7) {
      return Math.ceil((remainingDays / 7)) + " " + this.translate.instant("BANNER_CHALLENGE.WEEKS");
    } else {
      return remainingDays + " " + this.translate.instant("BANNER_CHALLENGE.DAYS");
    }
  }

  formatDateAsString(dateStr) {
    const momentDate = moment(dateStr, 'YYYY-MM-DD');
    return momentDate.format('DD/MM/YY');
  }
}
